import { render, staticRenderFns } from "./VisitorInfo.vue?vue&type=template&id=2a2d48ab"
import script from "./VisitorInfo.vue?vue&type=script&lang=js"
export * from "./VisitorInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports